import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-huurinkomsten',
  templateUrl: './huurinkomsten.component.html',
  styleUrls: ['./huurinkomsten.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class HuurinkomstenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private partnerAangifte = {} as Aangifte;
    private focusedElementId: string | null = null;

    public showSpinner = true;

    public huurInkomsten = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.huurInkomsten = this.fb.group({
            huur: this.fb.array<OmschrijvingEnBedrag>([]),
            kosten: this.fb.array<OmschrijvingEnBedrag>([]),
        })
    }

    get huur(): FormArray {
        return this.huurInkomsten.get("huur") as FormArray;
    }

    get kosten(): FormArray {
        return this.huurInkomsten.get("kosten") as FormArray;
    }

    addRijHuur(): void {
        this.huur.push(this.createHuurFormGroup()
        )
    }

    addRijKostenPU(): void {
        this.kosten.push(this.createKostenFormGroup()
        )
    }

    verwijderRijHuur(index: number): void {
        this.huur.removeAt(index);
        this.huurInkomsten.updateValueAndValidity()
        this.huurInkomsten.markAsDirty()
        this.saveForm();
    }

    verwijderRijKosten(index: number): void {
        this.kosten.removeAt(index);
        this.huurInkomsten.updateValueAndValidity()
        this.huurInkomsten.markAsDirty()
        this.saveForm();
    }

    createHuurFormGroup(ink?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: ink ? ink.omschrijving : undefined,
            bedrag: ink ? ink.bedrag : undefined
        } as OmschrijvingEnBedrag))
    }

    createKostenFormGroup(kost?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: kost ? kost.omschrijving : undefined,
            bedrag: kost ? kost.bedrag : undefined
        } as OmschrijvingEnBedrag))
    }



    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.updateForm();
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.huurInkomsten.dirty;
  }
    private updateForm(): void {
        // update ontvangsten
        const huurLijst = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.huurinkomstenEigenWoningen || [];
        const formArray = this.huurInkomsten.get('huur') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArray.length > huurLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }
        for (let i = 0; i < huurLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(huurLijst[i]);
            } else {
                const formGroup = this.createHuurFormGroup(huurLijst[i]);
                formArray.push(formGroup);
            }
        }
        // update kosten
        const kostenLijst = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.kostenVerhuurEigenWoningen || [];
        const formArrayKosten = this.huurInkomsten.get('kosten') as FormArray;
        while (formArrayKosten.length > kostenLijst.length) {
            formArrayKosten.removeAt(formArrayKosten.length - 1);
        }
        for (let i = 0; i < kostenLijst.length; i++) {
            if (i < formArrayKosten.length) {
                // Update existing control
                const control = formArrayKosten.at(i) as FormGroup;
                control.patchValue(kostenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createKostenFormGroup(kostenLijst[i]);
                formArrayKosten.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
            box1: {
                ...this.aangifte.box1,
                belastbareInkomstenUitEigenWoning: {
                    ...this.aangifte.box1?.belastbareInkomstenUitEigenWoning,
                    huurinkomstenEigenWoningen: this.huurInkomsten.value.huur,
                    kostenVerhuurEigenWoningen: this.huurInkomsten.value.kosten
                }
            }
        } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.huurInkomsten.markAsDirty()
        }, 0)
    }

}
